import { CustomButton, CustomImage, CustomModal, useText, Text } from '@src/components';
import modalClose from '@src/assets/icons/icon-close.svg';
import React, { useCallback } from 'react';
import '@src/styles/companyInformation/creditcards/provisionModal.scss';
import { updateProvisionDay } from '@src/store/slice/mobilExpressSlice';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

const AutomaticPaymentInstructionModal = ({
  modalVisible,
  handleModalVisible,
  activeCard,
  init,
  type = 1,
  checkedList,
  setCheckedList,
  setActivePanel,
}) => {
  const dispatch = useDispatch();
  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      const updatePromises = (checkedList || []).map(async checkedId => {
        return dispatch(
          updateProvisionDay({
            VouId: checkedId,
            ProvisionDay: 0,
            CardToken: activeCard.cardToken,
            Type: type,
          })
        );
      });

      await Promise.all(updatePromises);

      await init();

      handleModalVisible(false);
      setCheckedList([]);
      setActivePanel(null);
    },
    [activeCard]
  );

  const handleCloseModal = useCallback(
    (e) => {
      e.preventDefault();
      handleModalVisible(false);
    },
    [handleModalVisible],
  );

  return (
    <CustomModal
      className="provision-date-modal"
      maskClosable={false}
      footer={false}
      title={useText('automaticPaymentInstruction')}
      visible={modalVisible}
      onCancel={handleCloseModal}
      closeIcon={<CustomImage src={modalClose} />}
    >
      <div className="provision-date-container">
        <h5>{activeCard?.maskedCardNumber}</h5>
        <div className="provision-info-text">
          <Text
            t={
              type === 1
                ? 'thisCardWillBeGivenAutomaticPaymentInstruction'
                : 'thisCardWillBeRemovedFromAutomaticPaymentInstruction'
            }
          />
        </div>

        <div className="footer-btn">
          <CustomButton
            id="companyInformation-creditCards-automaticPaymentInstructionModal-save-btn"
            className="save-btn"
            onClick={handleSubmit}
          >
            <Text t="approve2" />
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default AutomaticPaymentInstructionModal;

AutomaticPaymentInstructionModal.propTypes = {
  modalVisible: PropTypes.bool,
  handleModalVisible: PropTypes.func,
  activeCard: PropTypes.shape({
    cardToken: PropTypes.string,
    maskedCardNumber: PropTypes.string,
  }),
  init: PropTypes.func,
  type: PropTypes.number,
  checkedList: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  setCheckedList: PropTypes.func,
  setActivePanel: PropTypes.func,
};

AutomaticPaymentInstructionModal.defaultProps = {
  type: 1,
  checkedList: [],
};